import ReactDOM from "react-dom";
import { App } from "./App";

// Import global CSS from Stellar Design System
import "@stellar/design-system/build/styles.min.css";

ReactDOM.render(<App />, document.getElementById("root"));
